<template>
    <page>
        <module :title="id ? '编辑搭配套餐' : '新建搭配套餐'">
            <c-form ref="form">
                <c-form title="基础信息">
                    <c-form-item type="hidden" name="id" v-model="bundleId"></c-form-item>
                    <c-form-item type="input" label="套餐名称" name="bundle_name" required></c-form-item>
                    <c-form-item type="textarea" label="套餐描述" name="bundle_desc" required></c-form-item>
                    <c-form-item type="checkbox" label="可售范围" name="visible_user_type" :options="userLevelOptions" required
                                 word="选中则表示该等级会员可以享受当前活动优惠"></c-form-item>
                </c-form>

                <c-form title="套餐商品">
                    <c-form-item>
                        <m-operate border>
                            <c-button color="gray" hollow @click="$refs.productSelector.open()">添加商品</c-button>
                        </m-operate>
                        <c-table ref="productList" v-model="productList" height="auto" :paging="false" border>
                            <c-table-column label="商品信息" name="productName" width="250">
                                <template v-slot="{data}">
                                    <div class="flex-center">
                                        <c-image :src="oss(data.productImgUrl, 46, 46)" size="46" preview></c-image>
                                        <p class="flex-grow ellipsis-2" style="margin-left: 12px;">
                                            {{ data.productName }}
                                        </p>
                                    </div>
                                </template>
                            </c-table-column>
                            <c-table-column label="商品价格" name="productPrice" width="100">
                                <template v-slot="{data}">￥{{ data.productPrice }}</template>
                            </c-table-column>
                            <c-table-column label="商品状态" name="state" width="100">
                                <template v-slot="{data}">
                                    <span v-if="data.state == 0" style="color:red">{{dict.productState[data.state]}}</span>
                                    <span v-if="data.state == 1" style="color:#999999">{{dict.productState[data.state]}}</span>
                                    <span v-if="data.state == 2" style="color:green">{{dict.productState[data.state]}}</span>
                                    <span v-if="data.state == 3" style="color:blue">{{dict.productState[data.state]}}</span>
                                    <span v-if="data.state == 4" style="color:red">{{dict.productState[data.state]}}</span>
                                </template>
                            </c-table-column>
                            <c-table-column type="button" fixed="right" label="操作" width="100">
                                <template v-slot="row">
                                    <c-table-button @click="row.remove()">删除</c-table-button>
                                </template>
                            </c-table-column>
                        </c-table>

                    </c-form-item>
                </c-form>

                <c-form title="套餐价格">
                    <c-form-item type="number" label="套餐价格" name="bundle_price" decimal="2" required inputUnit="元"></c-form-item>
                    <c-form-item label="等级价格" required>
                        <c-table ref="levelPrice" v-model="levelPrices" height="auto" :paging="false" border width="500px">
                            <c-table-column label="等级名称" name="levelName" width="30">
                            </c-table-column>
                            <c-table-column label="等级价格" name="bundlePrice" width="100">
                                <template v-slot="{data}">
                                    <c-input v-model="data.bundlePrice" type="number" decimal="2" ></c-input> 元
                                </template>
                            </c-table-column>
                        </c-table>
                    </c-form-item>
                </c-form>
            </c-form>

            <template slot="button">
                <c-button size="m" @click="submit()">提交保存</c-button>
            </template>
        </module>

        <product-selector ref="productSelector" multiple @resolve="productSelectHandle"></product-selector>
    </page>
</template>

<script>
import productSelector from '@/components/service/product_selector.vue';
import {mapState} from "vuex";

export default {
    name: 'bundle_edit',

    components: {
        productSelector
    },

    props: {
        id: String
    },

    data() {
        return {
            bundleId: '',
            levelPrices:[],
            productList: [],
            stateOptions: [
                { name: '启用', value: 1 },
                { name: '禁用', value: 0 }
            ],
            userLevelOptions: []
        };
    },
    computed: {
        ...mapState(['dict']),
        ...mapState(['systemConfig'])
    },
    watch: {
        id() {
            this.getBundleDetail();
        }
    },

    mounted() {
        this.initUserLevelOptions();
        if (this.id){
            this.getBundleDetail();
        }else {
            this.getLevelList();
        }
    },

    methods: {
        //加载会员等级列表
        initUserLevelOptions(){
            this.request({
                url: '/user_level/options',
                data: {},
                success: data => {
                    this.userLevelOptions = Array.from(data, item => {
                        return {
                            name: item.name,
                            value: item.value
                        }
                    });
                }
            });
        },
        getBundleDetail() {
            this.request({
                url: '/bundle/detail',
                data: { id: this.id },
                loading: true,
                success: data => {
                    var newData = {
                        bundle_name: data.bundleName,
                        bundle_desc: data.bundleDesc,
                        bundle_price: data.bundlePrice,
                        visible_user_type: data.visible_user_type
                    };
                    this.$refs.form.set(newData);
                    this.bundleId = data.id;
                    this.productList = data.products;
                    this.levelPrices = data.levelPrices;
                }
            });
        },
        getLevelList() {
            this.request({
                url: '/user_level/list',
                data: {"pageIndex":1,"pageSize":100},
                loading: true,
                success: data => {
                    var sortData = data.sort((a, b) => a.sort_id - b.sort_id);
                    this.levelPrices = data.map(item => ({
                        levelId: item.id,
                        levelName: item.level_name,
                        bundlePrice: ''
                    }));
                }
            });
        },

        productSelectHandle(list) {
            /*list = list.filter(item => {
                return !this.productList.find(row => row.productId === item.product_id);
            });*/
            const formattedList = list.map(item => ({
                state: item.state,
                productId: item.product_id,
                productName: item.product_name,
                productImgUrl: item.product_img_url,
                productPrice: item.product_price,
                productItemNumber: item.product_itemnumber
            }));

            this.productList = this.productList.concat(formattedList);
        },

        submit() {
            this.$refs.form.submit({
                url: this.id ? '/bundle/edit' : '/bundle/add',
                rule: {
                    bundle_name: '请填写套餐名称',
                    bundle_desc: '请填写套餐描述',
                    visible_user_type: '请选择活动可售范围',
                    products: [{
                        type: 'function',
                        fun: () => this.productList.length > 1,
                        word: '请至少添加2个商品'
                    }],
                    bundle_price: '请填写套餐价格',
                    level_prices: [{
                        type: 'function',
                        fun: () => {
                            return this.levelPrices.length > 0 && this.levelPrices.every(item => item.bundlePrice !== undefined && item.bundlePrice !== '');
                        },
                        word: '请维护套餐等级价格，且每个等级价格都需填写'
                    }]
                },
                dataFormatter: data => {
                    if (this.id) {
                        data.id = this.id;
                    }
                    data.visible_user_type = data.visible_user_type?data.visible_user_type.join(','):'';
                    data.level_prices = this.levelPrices.map(item => ({
                        levelId: item.levelId,
                        bundlePrice: item.bundlePrice
                    }));
                    data.products = this.productList.map(item => ({
                        productId: item.productId
                    }));

                    return data;
                },
                success: () => {
                    this.$message({ text: '保存成功' });
                    this.$bus.$emit('m_bundle.update',{});
                    this.redirectTo('/bundle');
                }
            });
        }
    }
};
</script>
